module.exports = __webpack_public_path__ + "static/HumstSlab712BTWXX-Roman-15a408fe295122acfe3b879e0dfb8b07.woff";